import { isValidTextInput } from '@acceligentllc/shared/utils/text';

import type ReportTypeFM from './formModel';

export function validate(values: ReportTypeFM) {
	const errors: ValidationErrors = {};

	if (!isValidTextInput(values.name)) {
		errors.name = 'Name is required';
	}

	return errors;
}
